export class SetorDto {
  id?: number = -1;
    nome: string = "";
    sigla: string = "";
    cor: string = "";
    usuarios?: number = -1;
}